












import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { client } from "@/api/index";
import { localSet } from "@/utils/index";
import { handleResponse } from "@/utils/request";
import { LoginReq } from "@/pbjs/external/user/user_pb";

@Component({
  name: "googleAuth"
})
export default class GoogleAuth extends Vue {
    @Prop() qrCodeBase64: any;
    @Prop() qrCodeType: any;
    private confirmScanQRCode() {
        this.$emit("returnIsShow", 1);
    }

    private closeAddDialog() {
        this.$emit("returnIsShow", 0);
    }
}
